import { snakeCase } from 'lodash';

export const convertEnumFilterItems = (object: { [key: string]: string }) =>
  [{ id: null, name: '-' }].concat(
    Object.keys(object).map((key) => ({
      id: snakeCase(key).toUpperCase(),
      name: key,
    })),
  );
